import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";

export const CardSkeleton = () => (
    <div className="border rounded-lg p-1 mb-6 bg-[var(--q3-surface-default)] animate-pulse">
        <div className="flex justify-between items-center">
            <div>
                <div className="h-6 w-48 rounded mb-2 bg-[var(--q3-surface-default)]" ></div>
                <div className="h-4 w-64 rounded bg-[var(--q3-surface-default)]" ></div>
            </div>
            <div className="h-6 w-6 rounded-full bg-[var(--q3-surface-default)]" ></div>
        </div>
    </div>
);

export const MistakesTableSkeleton = () => (
    <div className="border border-[var(--q3-stroke-light)] rounded-lg bg-[var(--q3-surface-default)] animate-pulse">
        <div className="flex justify-between items-center p-4 border-b border-[var(--q3-stroke-light)]">
            <div className="h-6 w-40 rounded bg-[var(--q3-surface-default)]" ></div>
            <div className="h-10 w-32 rounded-md bg-[var(--q3-surface-default)]" ></div>
        </div>
        <div className="p-4 space-y-4">
            {/* Column Titles */}
            <div className="flex justify-between text-sm">
                <div className="h-5 w-2/5 rounded bg-[var(--q3-surface-default)]" ></div>
                <div className="h-5 w-1/5 rounded ml-4 bg-[var(--q3-surface-default)]" ></div>
                <div className="h-5 w-1/5 rounded ml-4 bg-[var(--q3-surface-default)]" ></div>
                <div className="h-5 w-1/5 rounded ml-4 bg-[var(--q3-surface-default)]" ></div>
            </div>
            {[...Array(5)].map((_, i) => (
                <div key={i} className="flex items-center justify-between p-3 rounded-md" style={{ border: '1px solid var(--q3-stroke-light)' }}>
                    <div className="h-5 w-2/5 rounded bg-[var(--q3-surface-default)]"></div>
                    <div className="h-5 w-1/5 rounded ml-4 bg-[var(--q3-surface-default)]"></div>
                    <div className="h-5 w-1/5 rounded ml-4 bg-[var(--q3-surface-default)]"></div>
                    <div className="h-5 w-1/5 rounded ml-4 bg-[var(--q3-surface-default)]"></div>
                </div>
            ))}
        </div>
    </div>
);

export const SubjectTabsSkeleton = () => {
    return (
        <div className="mb-6 flex flex-row gap-2.5 border-b-2 border-[var(--q3-stroke-light)] bg-surface-default px-[15px] pt-[5px]">

            {[...Array(3)].map((_, index) => (
                <div key={index} className="flex flex-row items-center gap-2.5 px-5 py-2.5">
                    <div className="h-5 w-5 animate-pulse rounded-full bg-[var(--q3-surface-default)]"></div>
                    <div className="h-4 w-20 animate-pulse rounded-md bg-[var(--q3-surface-default)]"></div>
                </div>
            ))}
        </div>
    );
};

export const FiltersSkeleton = () => (
    <div className="mb-6 flex animate-pulse flex-wrap items-center gap-2">
        <div className="h-9 w-40 rounded-full bg-[var(--q3-surface-default)]"></div>
        <div className="h-8 w-px bg-[var(--q3-surface-default)]"></div>
        <div className="h-9 w-48 rounded-full bg-[var(--q3-surface-default)]"></div>
        <div className="h-8 w-px bg-[var(--q3-surface-default)]"></div>
        <div className="h-9 w-24 rounded-full bg-[var(--q3-surface-default)]"></div>
        <div className="h-9 w-36 rounded-full bg-[var(--q3-surface-default)]"></div>
        <div className="h-9 w-32 rounded-full bg-[var(--q3-surface-default)]"></div>
    </div>
);

// Skeleton for the main content (Pie Chart and Question List)
export const ContentAreaSkeleton = ({ isTestWise = false }) => {
    const SubjectTabsSkeleton = () => (
        <div className="flex flex-row gap-2.5 border-b-2 border-[var(--q3-stroke-light)] bg-surface-default px-[15px] pt-[5px]">
            {[...Array(3)].map((_, index) => (
                <div key={index} className="flex flex-row items-center gap-2.5 px-5 py-2.5">
                    <div className="h-5 w-5 animate-pulse rounded-full bg-[var(--q3-surface-default)]"></div>
                    <div className="h-4 w-20 animate-pulse rounded-md bg-[var(--q3-surface-default)]"></div>
                </div>
            ))}
        </div>
    );

    const QuestionItemSkeleton = () => (
        <div className="border-b px-5 py-4">
            <div className="flex items-start gap-6">
                <div className="mt-1 h-5 w-8 animate-pulse rounded-md bg-[var(--q3-surface-default)]"></div>
                <div className="flex flex-1 flex-col items-start gap-3">
                    <div className="flex flex-wrap items-center gap-3">
                        <div className="h-5 w-20 animate-pulse rounded-sm bg-[var(--q3-surface-default)]"></div>
                        <div className="h-5 w-24 animate-pulse rounded-sm bg-[var(--q3-surface-default)]"></div>
                        <div className="h-4 w-48 animate-pulse rounded-md bg-[var(--q3-surface-default)]"></div>
                    </div>
                    <div className="w-full space-y-2">
                        <div className="h-4 w-full animate-pulse rounded-md bg-[var(--q3-surface-default)]"></div>
                        <div className="h-4 w-3/4 animate-pulse rounded-md bg-[var(--q3-surface-default)]"></div>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <div className="w-full animate-pulse">
            <CardSkeleton />
            <Card className='py-3 gap-0'>
                <CardHeader><div className="h-13 w-40 rounded-md bg-[var(--q3-surface-default)]"></div></CardHeader>
                <hr />
                <CardContent className='py-5'>
                    {isTestWise && <SubjectTabsSkeleton />}
                    <div>{[...Array(5)].map((_, index) => <QuestionItemSkeleton key={index} />)}</div>
                    <div className="mt-6 flex items-center justify-center gap-4">
                        <div className="h-9 w-20 rounded-md bg-[var(--q3-surface-default)]"></div>
                        <div className="h-9 w-9 rounded-full bg-[var(--q3-surface-default)]"></div>
                        <div className="h-9 w-9 rounded-full bg-[var(--q3-surface-default)]"></div>
                        <div className="h-9 w-9 rounded-full bg-[var(--q3-surface-default)]"></div>
                        <div className="h-9 w-20 rounded-md bg-[var(--q3-surface-default)]"></div>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};
